import React, { useEffect, useState, Suspense } from "react";
import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import SearchBar from "components/SearchBar/SearchBar";
import withToasts from "hoc/withToasts";
import BottomCartBar from "components/BottomCartBar/BottomCartBar";
import { connect } from "react-redux";
import { requestVMdetails } from "store/actions/vmDetails.action";
import { requestVmStock } from "store/actions/vmStock.action";
import "containers/Home/Home.css";
import {
  getCartCache,
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
  initFetchInterceptor,
  preventReloadPage,
  removeDuplicatesFromProductsJson,
} from "utils/commonMethods";
import { pushItemsToCart } from "store/actions/cart.action";
import { useDispatch } from "react-redux";
import { API_KEYS } from "constants/apiEndpoints";
import { requestPostFetchApi } from "utils/apiMethods";
import { GET_VM_POLLING_TIME } from "constants/constants";
import useAuthentication from "hooks/useAuthentication";

//Lazy loading.
const BottomUpModal = React.lazy(() =>
  import("components/BottomUpModal/BottomUpModal")
);
const RequestProduct = React.lazy(() =>
  import("containers/Home/RequestProduct/RequestProduct")
);
const HomeProducts = React.lazy(() =>
  import("containers/Home/HomeProducts/HomeProducts")
);

const Footer = React.lazy(() => import("containers/Footer/Footer"));

function Home({
  requestVMdetails,
  requestVmStock,
  vendingMachine,
  vendingMachineItems,
  showErrorToast,
  showSuccessToast,
  vendingMachineFilters,
}) {
  const componentTexts = window.appTexts.home_page;
  const [productList, setProductList] = useState(null);
  const [showRequestProduct, setShowRequestProduct] = useState(false);
  const [vmIsOffline, setVmIsOffline] = useState(false);

  //Validations for vm is offline
  const handleVmIsOffline = function () {
    requestPostFetchApi(API_KEYS.GET_VM_DETAILS, {
      phone_no: getUserPhone(),
      hash: getUserHashToken(),
      uuid: getVendingMachineUuid(),
    }).then((response) => {
      //VM not found
      if (!response.vendingMachine) {
        return;
      }

      return setVmIsOffline(!response.vendingMachine.is_online);
    });
  };

  useEffect(() => {
    //Api polling for get vm details
    handleVmIsOffline();
    //Polling
    setInterval(() => {
      handleVmIsOffline();
    }, GET_VM_POLLING_TIME);
    preventReloadPage();
  }, []);

  useEffect(() => {
    //Get Vending Machine & stock Details.
    requestVMdetails();
    requestVmStock();
  }, [requestVMdetails, requestVmStock]);
  const dispatch = useDispatch();
  //Store next items in redux.
  const dispatchItemsToCart = function (nextItemsInCart) {
    dispatch(pushItemsToCart(nextItemsInCart));
  };

  //Lifecycle Events
  useEffect(() => {
    if (vendingMachineItems) {
      let cachedCart = getCartCache();
      let nextItemsInCart = [];

      //Retreive cached cart data.
      if (cachedCart && cachedCart.length) {
        nextItemsInCart = cachedCart
          .map((element) => {
            //Validations to check if stock is available and item is available.
            let currentElementInVm = vendingMachineItems.find(
              (item) => item.sid === element.item.sid
            );

            //Return if item stock not available or item not found
            if (!currentElementInVm || !currentElementInVm.stk) {
              return;
            }

            //Set quantity to minimum of stock available and user specified stock.
            element.quantity = Math.min(
              element.quantity,
              currentElementInVm.stk
            );
            return element;
          })
          .filter((ele) => ele);

        //Push cached cart.
        dispatchItemsToCart(nextItemsInCart);
      }

      //Set vending machine items
      setProductList(vendingMachineItems);
    }
  }, [vendingMachineItems]);

  // Interceptor for fetch
  initFetchInterceptor(showErrorToast);

  //Controllers.
  const handleSearchBar = function (nextProductList) {
    return setProductList(nextProductList);
  };

  const toggleRequestProductPopup = function () {
    return setShowRequestProduct(!showRequestProduct);
  };

  return (
    <React.Fragment>
      <HomeHeader vmName={vendingMachine.name} />
      <section>
        <div className="sample_homepage_overview">
          {componentTexts.common_text.home_sample_overview}
        </div>
        <SearchBar
          data={vendingMachineItems}
          onChange={handleSearchBar}
          filterKey="name"
        />
        <Suspense fallback={<React.Fragment></React.Fragment>}>
          <HomeProducts
            data={productList}
            uniqueProductsData={removeDuplicatesFromProductsJson(
              productList,
              "iUID"
            )}
            filters={vendingMachineFilters}
            showErrorToast={showErrorToast}
            showSuccessToast={showSuccessToast}
          />
        </Suspense>
      </section>
      <Suspense fallback={<React.Fragment></React.Fragment>}>
        <BottomUpModal
          open={showRequestProduct}
          modalTitle={componentTexts.request_popup.request_popup_title}
          closeHandler={toggleRequestProductPopup}
        >
          <RequestProduct
            componentTexts={componentTexts.request_popup}
            closeHandler={toggleRequestProductPopup}
            showSuccessToast={showSuccessToast}
            showErrorToast={showErrorToast}
          />
        </BottomUpModal>
      </Suspense>
      <Suspense fallback={<React.Fragment></React.Fragment>}>
        <Footer />
      </Suspense>
      <BottomCartBar />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  vendingMachine: state.vmDetailsReducer,
  vendingMachineItems: state.vmStockReducer.items,
  vendingMachineFilters: state.vmStockReducer.filters,
});

const mapDispatchToProps = (dispatch) => ({
  requestVMdetails: () => dispatch(requestVMdetails()),
  requestVmStock: () => dispatch(requestVmStock()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withToasts(Home));
